module.exports = __webpack_public_path__ + "static/division-shadows-dont-403df08a19a63ffb35f8b266cae6033c.png";